import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../design/img/yaystack-logo.png";

class ReturnNavBar extends Component {
  static contextTypes = {
    router: () => null // replace with PropTypes.object if you use them
  };
  state = {};
  render() {
    return (
      <nav className="navbar navigationBar yaystack_return_nav_bar">
        {this.renderReturn()}
        {this.renderLogo()}
      </nav>
    );
  }
  renderReturn = e => {
    if (this.context.router.history.action === "PUSH") {
      if (this.props.logo === true) {
        return (
          <Link to={this.props.link}>
            <div className="yaystack_icon cursor_btn">
              <ion-icon name="ios-arrow-back" class="ion-icon" />
            </div>
          </Link>
        );
      }
      return (
        <div
          className="yaystack_icon cursor_btn"
          onClick={this.context.router.history.goBack}
        >
          <ion-icon name="ios-arrow-back" class="ion-icon" />
        </div>
      );
    } else {
      return (
        <Link to={this.props.link}>
          <div className="yaystack_icon cursor_btn">
            <ion-icon name="ios-arrow-back" class="ion-icon" />
          </div>
        </Link>
      );
    }
  };

  renderLogo() {
    if (this.props.logo === true) {
      return <img src={Logo} alt="Yaystack Logo" />;
    }
  }
}

export default ReturnNavBar;



// WEBPACK FOOTER //
// ./src/components/returnBar.jsx